import { LitElement, html } from 'lit';
// eslint-disable-next-line
import styles from '!!lit-css-loader!postcss-loader!sass-loader!./MediaViewer.scss';

class YoutubeVideo extends LitElement {
  static styles = [styles];

  static get properties() {
    return {
      src: { type: String },
      muted: { type: Boolean },
    };
  }

  /**
   * YouTube video ID is always 11 characters long
   */
  static YOUTUBE_ID_LENGTH = 11;

  /**
   * Extracts YouTube video ID from various URL formats using clear, maintainable patterns.
   * Supported formats:
   *   - https://youtu.be/VIDEO_ID
   *   - https://www.youtube.com/watch?v=VIDEO_ID
   *   - https://www.youtube.com/embed/VIDEO_ID
   *   - https://www.youtube.com/v/VIDEO_ID
   *   - https://www.youtube.com/shorts/VIDEO_ID
   * @param {string} url - YouTube URL
   * @returns {string|null} Video ID or null if not found
   */
  static extractVideoId(url) {
    if (typeof url !== 'string') return null;

    const patterns = [
      // youtu.be/<id>
      /youtu\.be\/(?<id>[a-zA-Z0-9_-]{11})/,
      // youtube.com/watch?v=<id>
      /youtube\.com\/watch\?[^#]*v=(?<id>[a-zA-Z0-9_-]{11})/,
      // youtube.com/embed/<id>
      /youtube\.com\/embed\/(?<id>[a-zA-Z0-9_-]{11})/,
      // youtube.com/v/<id>
      /youtube\.com\/v\/(?<id>[a-zA-Z0-9_-]{11})/,
      // youtube.com/shorts/<id>
      /youtube\.com\/shorts\/(?<id>[a-zA-Z0-9_-]{11})/,
    ];

    // Use find() instead of for...of loop to comply with no-restricted-syntax
    const matchedPattern = patterns.find((pattern) => pattern.test(url));
    if (matchedPattern) {
      const match = url.match(matchedPattern);
      return match && match.groups && match.groups.id ? match.groups.id : null;
    }

    return null;
  }

  render() {
    const { src, muted } = this;
    const videoId = YoutubeVideo.extractVideoId(src);

    if (!videoId) {
      return html`<div class="youtube-error">Invalid YouTube URL</div>`;
    }

    return html`
      <iframe
        width="560"
        height="315"
        class="youtube-iframe"
        src="//www.youtube.com/embed/${videoId}?autoplay=1&enablejsapi=1&html5=1&mute=${+muted}&controls=0&loop=1&playlist=${videoId}"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    `;
  }
}

export default YoutubeVideo;
